import tmhRequest from '@/config/tmhRequest'

export default {
    searchProductOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/productorderreport/searchproductorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchProductOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/productorderreport/searchproductorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportProductOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/productorderreport/exportproductorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/productorderreport.js